import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";


export const qcRuleApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchQcRules: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/get-all-qcRules?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['qcRules'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getQcRuleById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-qc-logic/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['qcRuleById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createQcRule: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/qcRule`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['qcRules'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Qc Rule");
            },
        }),
        updateQcRule: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update/qcRule/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['qcRules', 'qcRuleById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Updated","Qc Rule")
            },
        }),

        deleteQcRuleById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete/qcLogic/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['qcRules'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Qc Rule");
            },
        }),
        exportQcRuleData: build.query({
            query: (query) => {
                return {
                    url: `/export/qcLogic`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("qcRule"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});


export const {
    useSearchQcRulesQuery,
    useGetQcRuleByIdQuery,
    useCreateQcRuleMutation,
    useUpdateQcRuleMutation,
    useDeleteQcRuleByIdMutation,
    useLazyExportQcRuleDataQuery,
} = qcRuleApi;